import { z } from 'zod';
import { CONTROLLER_TYPES, MACHINE_STATUSES } from '../constants/enums.js';

export const machineSchema = z.object({
  machine_id: z.string().min(1).max(64),
  shop_id: z.string().min(1).max(64),
  controller_type: z.enum(CONTROLLER_TYPES),
  status: z.enum(MACHINE_STATUSES),
  spindle_rpm: z.number().finite().min(0),
  feed_rate: z.number().finite().min(0),
  program_name: z.string(),
  alarm_code: z.string().nullable(),
  oee_percent: z.number().finite().min(0).max(100),
  cycle_time_seconds: z.number().finite().min(0),
  last_seen_at: z.string().datetime({ offset: true }),
  updated_at: z.string().datetime({ offset: true }),
});

export type Machine = z.infer<typeof machineSchema>;
